import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
// import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import { createSearchParams, useSearchParams, useNavigate } from 'react-router-dom';
import { objectToQueryString, apiHelper, baseUrl } from 'helpers/util';
import { notify } from 'helpers/globalFunctions';

import ColumnBox from 'components/ColumnBox';
import RowBox from 'components/RowBox';
import CardList from 'components/CardList';
import CardItem from 'components/CardItem';
import SmallestHeading from 'components/SmallestHeading';
import SmallHeading from 'components/SmallHeading';
import CategoryIcon from '@mui/icons-material/Category';

import ItemCounter from 'modules/BillingSystem/ItemCounter';
import SettingsIcon from '@mui/icons-material/Settings';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

import { DateTime } from 'luxon';
import html2canvas from 'html2canvas';

export default function Form(props) {
    const navigate = useNavigate();
    const [ productId, setProductId ] = useState(null);
    const [ productName, setProductName ] = useState('');
    const [ cost, setCost ] = useState('');
    const [ unit, setUnit ] = useState('');
    const [ unitOptions, setUnitOptions ] = useState([]);
    const [ paymentModeOptions ] = useState([ "Cash", "Google Pay", "Phone Pay", "PayTM", "Other (Add in remarks)" ])
    const [ paymentMode, setPaymentMode ] = useState('');
    const [ counterName, setCounterName ] = useState('');
    const [ isVegetable, setIsVegetable] = useState(false);

    const [ isMenuDialogOpen, setIsMenuDialogOpen ] = useState(false)

    const [ products, setProducts ] = useState([]);
    const [ shopMetadata, setShopMetadata ] = useState({});
    const [ totalAmount, setTotalAmount ] = useState(0);
    const [ totalQuantity, setTotalQuantity ] = useState(0);

    const [ isFormSubmitting, setIsFormSubmitting ] = useState(false);


    const loadProducts = function() {
        const apiParams = {
            "doctype": "FOLK Billing Item",
            "fields": JSON.stringify(["name", "item_name", "item_cost", "is_inactive"]),
            "order_by": "item_name asc",
            "limit": 1000,
            "filters": JSON.stringify([[ 'is_inactive', '=', false ]])
        }
        apiHelper.get({ "url": `${baseUrl}/.netlify/functions/erp_api`,
            "params": apiParams })
        .then(response => {
            if (response.status) { setProducts(response.json.data); }
            else { console.log(response.json); }
        })
    }

    const loadMetadata = function() {
        const apiParams = {
            "doctype": "FOLK Billing Metadata",
            "fields": JSON.stringify(["shop_name", "shop_logo"])
        }
        apiHelper.get({ "url": `${baseUrl}/.netlify/functions/erp_api`,
            "params": apiParams })
        .then(response => {
            if (response.json.data && response.json.data.length > 0) {
                setShopMetadata(response.json.data[0]);
            } else { console.log(response.json); }
        })
    }

    const resetOrderInfo = function() {
        setPaymentMode('')
        for (const p of products) {
            p.count_selected = 0;
        }
        setProducts([...products]);
    }

    const onClickSave = function() {
        setIsFormSubmitting(true);
        const orderItems = [];
        for (const p of products) {
            if (p.count_selected > 0) {
                orderItems.push({
                    'item': p.name,
                    'each_item_cost': p.item_cost,
                    'quantity': p.count_selected,
                    'order_item_cost': p.count_selected * p.item_cost
                })
            }
        }
        const payload = {
            'payment_mode': paymentMode,
            'total_amount': totalAmount,
            'timestamp': DateTime.now().toFormat('yyyy-MM-dd HH:mm:ss'),
            'order_items': orderItems
        }

        const apiParams = { "doctype": "FOLK Billing Order" };
        productId && (apiParams["name"] = productId)

        let apiUrl = `${baseUrl}/.netlify/functions/erp_api`;
        let apiPromise = null;
        if (productId) {
            apiPromise = apiHelper.put({ "url": apiUrl, "params": apiParams, "data": payload })
        } else {
            apiPromise = apiHelper.post({ "url": apiUrl, "params": apiParams, "data": payload })
        }
        apiPromise
        .then(response => {
            if (response.status) {
                notify.success({ "description": "Order successfully created !" });
                const printNode = document.getElementById('order-summary-content')
                console.log(printNode.offsetHeight);
                html2canvas(printNode, {
                    width: printNode.offsetWidth, height: printNode.offsetHeight + 100,
                    useCORS: true, allowTaint:true,
                    scale: 1 })
                .then( c => {
                        let context = c.getContext('2d');
                        const imageDataUrl = c.toDataURL("image/jpeg").split(';base64,')[1]
                        console.log(imageDataUrl)
                        if (window.AndroidApp) {
                            window.AndroidApp.printPrasadam(imageDataUrl);
                        }
                        setIsFormSubmitting(false);
                        setIsMenuDialogOpen(false);
                        resetOrderInfo();
                })
            } else { console.log(response.json); setIsFormSubmitting(false); }
        })
    }

    const onChangeCounter = (newVal, p) => {
        p.count_selected = newVal;
        setProducts([...products]);
    }

    const handleMenuDialogClose = function() {
        setIsMenuDialogOpen(false);
    }

    const onClickProceed = function() {
        setIsMenuDialogOpen(true);
    }

    const goToAdminScreen = function() {
        navigate({ "pathname": "report" })
    }
    const goToSettings = function() {
        navigate({ "pathname": "settings" })
    }

    useEffect(function() {
        loadProducts();
        loadMetadata();
    }, [])

    useEffect(function() {
        let totalQty = 0;
        let totalAmount = 0;
        for (const p of products) {
            if (p.count_selected) { totalQty += p.count_selected }
            if (p.item_cost && p.count_selected) { totalAmount += (p.count_selected * p.item_cost) }
        }
        setTotalQuantity(totalQty);
        setTotalAmount(totalAmount);
    }, [products])

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center',
            padding: '15px' }}>
            <ColumnBox sx={{ width: '100%', paddingBottom: '100px', alignItems: 'center' }}>
                <ColumnBox sx={{ justifyContent: 'center', alignItems: 'center' }}>
                    <img src={`http://folk.hkmhyderabad.org/${shopMetadata.shop_logo}`}
                        style={{ width: '35%', maxWidth: '200px' }}/>
                    <SmallHeading>{shopMetadata.shop_name}</SmallHeading>
                </ColumnBox>
                <Box sx={{ 'width': '95%',
                    'maxWidth': '700px',
                    'marginTop': '5px', 'marginBottom': '5px' }}>
                    <Table sx={{ width: '100%' }}>
                        <TableBody>
                        { products.map((p) => (
                            <TableRow sx={{ '& td, & th': { padding: '5px 7px' } }}
                                key={p.name}>
                                <TableCell sx={{ fontSize: '16px' }}>{p.item_name}</TableCell>
                                <TableCell align="right" sx={{ width: '1%', fontWeight: 'bold',
                                    whiteSpace: 'nowrap' }}>
                                    ₹ {p.item_cost}</TableCell>
                                <TableCell align="right" sx={{ width: '1%' }}>
                                    <ItemCounter value={p.count_selected}
                                        onChange={newVal => onChangeCounter(newVal, p)}></ItemCounter>
                                </TableCell>
                            </TableRow>
                            ))
                        }
                        </TableBody>
                    </Table>
                </Box>
            </ColumnBox>
            <RowBox sx={{ left: 'auto', right: 'auto',
                maxWidth: '90%', width: '500px', paddingBottom: '10px', paddingTop: '10px',
                position: 'fixed', bottom: 0, borderTop: '1px solid #60b246',
                alignItems: 'center', justifyContent: 'space-between' }}>
                {totalQuantity > 0 &&
                    <>
                        <Box sx={{ color: '#60b246', fontSize: '20px' }}>{`₹ ${totalAmount}`}</Box>
                        <Button size="medium" onClick={() => onClickProceed()}
                            variant="outlined">Next</Button>
                    </>
                }
                {totalQuantity === 0 &&
                    <>
                        <Box></Box>
                        <Box>
                            <Button size="medium" onClick={() => goToSettings()}
                                sx={{ marginRight: '5px' }}
                                variant="outlined"><CategoryIcon /></Button>
                            <Button size="medium" onClick={() => goToAdminScreen()}
                                variant="outlined"><MonetizationOnIcon /></Button>
                        </Box>
                    </>
                }
            </RowBox>
            
            <Dialog
                open={isMenuDialogOpen} onClose={handleMenuDialogClose}>
                <DialogContent>
                    <Box id="order-summary-content">
                        <ColumnBox sx={{ justifyContent: 'center', alignItems: 'center' }}>
                            <img src={`http://folk.hkmhyderabad.org/${shopMetadata.shop_logo}`}
                                style={{ width: '45%', maxWidth: '200px' }}/>
                            <SmallHeading>{shopMetadata.shop_name}</SmallHeading>
                            <SmallestHeading sx={{ marginTop: '10px', marginBottom: '10px' }}>
                                Order Summary</SmallestHeading>
                        </ColumnBox>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ '& td, & th': { padding: '5px 5px', fontSize: '18px', fontWeight: 'bold' } }}>
                                    <TableCell>Item</TableCell>
                                    <TableCell sx={{ width: '1%', whiteSpace: 'nowrap' }}
                                        align="right">Qty</TableCell>
                                    <TableCell sx={{ width: '1%', whiteSpace: 'nowrap' }}
                                        align="right">Amt</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {products.filter(p => p.count_selected > 0).map(p => (
                                <TableRow sx={{ '& td, & th': { padding: '5px 7px', fontSize: '18px', } }}
                                    key={p.name}>
                                    <TableCell>{p.item_name}</TableCell>
                                    <TableCell align="right" sx={{ width: '1%', whiteSpace: 'nowrap' }}>
                                        {p.count_selected}</TableCell>
                                    <TableCell align="right" sx={{ width: '1%', whiteSpace: 'nowrap' }}>
                                        {p.item_cost * p.count_selected}</TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                        <RowBox sx={{ justifyContent: 'space-between', color: '#60b246', fontSize: '16px',
                            alignItems: 'center',
                            marginTop: '10px', marginBottom: '10px' }}>
                            <Select value={paymentMode} size="small" displayEmpty
                                sx={{ height: '30px', fontSize: '18px', marginRight: '7px' }}
                                onChange={ e => setPaymentMode(e.target.value) }>
                                <MenuItem sx={{ minHeight: '0px', fontSize: '15px' }} value=""><em style={{ color: 'grey' }}>Payment Mode</em></MenuItem>
                                <MenuItem sx={{ minHeight: '0px', fontSize: '15px' }} value="Cash">Cash</MenuItem>
                                <MenuItem sx={{ minHeight: '0px', fontSize: '15px' }} value="Google Pay">Google Pay</MenuItem>
                                <MenuItem sx={{ minHeight: '0px', fontSize: '15px' }} value="Phone Pe">Phone Pe</MenuItem>
                                <MenuItem sx={{ minHeight: '0px', fontSize: '15px' }} value="PayTM">PayTM</MenuItem>
                                <MenuItem sx={{ minHeight: '0px', fontSize: '15px' }} value="Others">Other</MenuItem>
                            </Select>
                            <Box sx={{ fontSize: '24px' }}>{`₹ ${totalAmount}`}</Box>
                        </RowBox>
                        <Box sx={{ textAlign: 'center', marginTop: '10mm', fontSize: '22px' }}>
                            Hare Krishna !!<br/>Have a nice day</Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsMenuDialogOpen(false)}>Cancel</Button>
                    {isFormSubmitting ? <CircularProgress /> : 
                        <Button disabled={ paymentMode === '' }
                            onClick={onClickSave}>Save & Print</Button>}
                </DialogActions>
            </Dialog>
        </Box>
    );
}
